import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { ButtonLabel, FilterColumn, FilterGroup, FilterGroupLabel, FilterItem, IconButton } from './ContentPush.styles'
import { Button, Column, Table } from '../..'
import { routes } from '../../../constants'
import { contentPush as cpProps } from '../../../types'
import Padding from '../../Padding'
import { withSize } from '../../utils'
import contentPushDisplay from './ContentPush.table'
import { usePageTitle } from '../../../actions/app'

const ContentPush = ({ data, onChangeSearch, valueSearch, statusList, groups, requiredLevels, onSelectGroup, onSelectLevel, onSelectStatus, isMobile, t }) => {
    usePageTitle(t('Content push'))

    return (
        <Fragment>
            <FilterColumn width={isMobile ? '100%' : '25%'} notFullHeight={isMobile}>
                {statusList && (
                    <Padding bottom size="sm">
                        <FilterGroupLabel>{t('Status')}</FilterGroupLabel>
                        <FilterGroup>
                            {statusList.map((status, index) => (
                                <FilterItem key={status.id} onClick={() => onSelectStatus(index)}>
                                    <Column width="75%">{t(status.name)}</Column>
                                    <Column width="25%">{status.selected && <IconButton icon="check" />}</Column>
                                </FilterItem>
                            ))}
                        </FilterGroup>
                    </Padding>
                )}
                {groups && (
                    <Padding bottom size="sm">
                        <FilterGroupLabel>{t('Group')}</FilterGroupLabel>
                        <FilterGroup>
                            {groups.map((group, index) => (
                                <FilterItem key={group.id} onClick={() => onSelectGroup(index)}>
                                    <Column width="75%">{t(group.name)}</Column>
                                    <Column width="25%">{group.selected && <IconButton icon="check" />}</Column>
                                </FilterItem>
                            ))}
                        </FilterGroup>
                    </Padding>
                )}
                {requiredLevels && (
                    <Padding bottom size="sm">
                        <FilterGroupLabel>{t('Level Required')}</FilterGroupLabel>
                        <FilterGroup>
                            {requiredLevels.map((level, index) => (
                                <FilterItem key={level.id} onClick={() => onSelectLevel(index)}>
                                    <Column width="75%">{t(level.name)}</Column>
                                    <Column width="25%">{level.selected && <IconButton icon="check" />}</Column>
                                </FilterItem>
                            ))}
                        </FilterGroup>
                    </Padding>
                )}
            </FilterColumn>
            <Column width={isMobile ? '100%' : '75%'}>
                <Table
                    data={data}
                    display={contentPushDisplay({
                        t,
                    })}
                    keyField="code"
                    onChangeSearch={onChangeSearch}
                    title={t('Content push')}
                    valueSearch={valueSearch}
                >
                    <Link to={routes['CONTENT_PUSH_FORM:NEW']}>
                        <Button size="sm">
                            <FontAwesomeIcon icon="plus" />
                            <ButtonLabel>{t('Create')}</ButtonLabel>
                        </Button>
                    </Link>
                </Table>
            </Column>
        </Fragment>
    )
}

ContentPush.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape(cpProps)).isRequired,
    onChangeSearch: PropTypes.func.isRequired,
    valueSearch: PropTypes.string,
    statusList: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            selected: PropTypes.bool,
        })
    ),
    groups: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            selected: PropTypes.bool,
        })
    ),
    requiredLevels: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            selected: PropTypes.bool,
        })
    ),
    onSelectGroup: PropTypes.func,
    onSelectLevel: PropTypes.func,
    onSelectStatus: PropTypes.func,
    isMobile: PropTypes.bool,
    t: PropTypes.func.isRequired,
}

ContentPush.defaultProps = {
    valueSearch: '',
    statusList: null,
    groups: null,
    requiredLevels: null,
    onSelectGroup: () => null,
    onSelectLevel: () => null,
    onSelectStatus: () => null,
    isMobile: false,
}

export default withSize(withTranslation()(ContentPush))
